export const pollCreationFailedNotificationTranslator = ({ options: { notification }, t }) => {
    if (typeof notification?.metadata?.reason === 'string' &&
        notification.metadata.reason.length) {
        return t('Failed to create the poll due to {{reason}}', {
            reason: notification.metadata.reason.toLowerCase(),
        });
    }
    return t('Failed to create the poll');
};
